import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { StyleSheet, Animated, View } from 'react-native';
import CardContent from './PnmacCardContent';
import CardActions from './PnmacCardActions';
import CardCover from './PnmacCardCover';
import CardTitle from './PnmacCardTitle';
import Surface from '../Surface';
var PnmacCard = /** @class */function (_super) {
  __extends(PnmacCard, _super);
  function PnmacCard() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      elevation: new Animated.Value(_this.props.elevation)
    };
    _this.handlePressIn = function () {
      Animated.timing(_this.state.elevation, {
        toValue: 8,
        duration: 150 * 1.0,
        useNativeDriver: false
      }).start();
    };
    _this.handlePressOut = function () {
      Animated.timing(_this.state.elevation, {
        toValue: _this.props.elevation,
        duration: 150 * 1.0,
        useNativeDriver: false
      }).start();
    };
    return _this;
  }
  PnmacCard.prototype.render = function () {
    var _a = this.props,
      children = _a.children,
      cardElevation = _a.elevation,
      onLongPress = _a.onLongPress,
      onPress = _a.onPress,
      style = _a.style,
      testID = _a.testID,
      accessible = _a.accessible,
      rest = __rest(_a, ["children", "elevation", "onLongPress", "onPress", "style", "testID", "accessible"]);
    var elevation = this.state.elevation;
    return /*#__PURE__*/React.createElement(Surface, __assign({
      style: [{
        borderRadius: 10,
        elevation: elevation
      }, style],
      nativeID: rest.idTag1
    }, rest), /*#__PURE__*/React.createElement(View, {
      accessibilityLevel: 1,
      style: styles.innerContainer,
      nativeID: rest.idTag3
    }, children));
  };
  PnmacCard.Content = CardContent;
  PnmacCard.Actions = CardActions;
  PnmacCard.Cover = CardCover;
  PnmacCard.Title = CardTitle;
  PnmacCard.defaultProps = {
    elevation: 1
  };
  return PnmacCard;
}(React.Component);
var styles = StyleSheet.create({
  innerContainer: {
    flexGrow: 1,
    flexShrink: 1
  }
});
export default PnmacCard;